// extracted by mini-css-extract-plugin
module.exports = {"ContactoFormCard":"ContactoForm_ContactoFormCard__Ampxh","ContactoFormCardWrapper":"ContactoForm_ContactoFormCardWrapper__2i6Qa"};